/*
 * Copyright 2025 Kazimierz Pogoda / Xemantic
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

package com.xemantic.markdown.editor

import com.xemantic.kotlin.js.dom.html.a
import com.xemantic.kotlin.js.dom.html.footer
import com.xemantic.kotlin.js.dom.html.h6
import com.xemantic.kotlin.js.dom.html.header
import com.xemantic.kotlin.js.dom.html.main
import com.xemantic.kotlin.js.dom.html.nav
import com.xemantic.kotlin.js.dom.invoke
import kotlinx.browser.document

/**
 * Main entry point for the Markdown Editor application.
 *
 * Sets up the MVVM architecture by creating the ViewModel and View,
 * then renders the UI into the document body.
 */
fun main() {
    val viewModel = MarkdownViewModel()
    document.body!! {
        header("surface-container fixed") {
            nav("center-align") {
                h6 {
                    +"xemantic-markdown-editor"
                }
            }
        }
        main("responsive") {
            markdownEditorView(viewModel)
        }
        footer("surface-container fixed") {
            nav("center-align") {
                +"GitHub: "
                a(href = "https://github.com/xemantic/xemantic-markdown-editor") {
                    +"https://github.com/xemantic/xemantic-markdown-editor"
                }
            }
        }
    }
}
